// extracted by mini-css-extract-plugin
module.exports = {"image":"Carousel_image__3n2ll","detail":"Carousel_detail__480-3"};